"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillingDetailsUI = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../../shared/core");
var analytics_subjects_1 = require("../../../analytics-subjects");
var copy_1 = require("../../../copy");
var legacy_mapper_1 = require("../../../utils/legacy-mapper");
var components_1 = require("./components");
var BillingDetails = function (_a) {
    var _b;
    var data = _a.data;
    var _c = (0, core_1.useComponents)(), Card = _c.Card, Stack = _c.Stack;
    var isCurrentPeriod = (0, legacy_mapper_1.isActiveBillingPeriod)(data);
    var copy = (0, core_1.useCopy)(copy_1.defaultOptions).copy;
    var totalCharge = data.totalCharge, start = data.start, end = data.end, isStatementAvailable = data.isStatementAvailable, payments = data.payments, electricityCharges = data.electricityCharges, gas = data.gas, upgrades = data.upgrades, transactions = data.transactions;
    var accountId = (0, ui_tools_1.useAccountContext)().accountId;
    if (!accountId) {
        return null;
    }
    return (react_1.default.createElement(ui_tools_1.AnalyticsView, { name: analytics_subjects_1.BILLING_DETAILS_PAGE, properties: (_b = {
                isCurrentPeriod: isCurrentPeriod
            },
            _b[core_1.INTERNAL_EVENT_FLAG] = true,
            _b.variant = 'billingDetailsV2',
            _b) },
        react_1.default.createElement("section", null,
            react_1.default.createElement(Card, null,
                react_1.default.createElement(Stack, { spaceBetween: [4, 8] },
                    react_1.default.createElement(components_1.Header, { start: start, end: end, totalCharge: totalCharge.grossCharge.pounds, isStatementAvailable: isStatementAvailable, accountId: accountId, isCurrentPeriod: isCurrentPeriod }),
                    react_1.default.createElement(components_1.BalanceSection, { "data-testid": "balance-section", openingBalance: data.openingBalance, closingBalance: data.closingBalance, totalCharge: data.totalCharge, payments: data.payments, transactions: transactions }),
                    react_1.default.createElement(components_1.TotalChargesSection, { "data-testid": "total-charges-section", electricityCharges: electricityCharges, gas: gas, upgrades: upgrades, transactions: transactions, totalCharge: data.totalCharge }),
                    react_1.default.createElement(components_1.PaymentsSection, { payments: payments }),
                    react_1.default.createElement(core_1.FeedbackPrompt, { id: "billingDetails", probability: 25, label: copy('feedbackPromptLabelBillingDetails') }))))));
};
var BillingDetailsUI = function (_a) {
    var data = _a.data, isLatestPeriod = _a.isLatestPeriod, meterReadingsResponse = _a.meterReadingsResponse;
    if (!data || isLatestPeriod) {
        return react_1.default.createElement(components_1.EmptyState, { meterReadingsInfo: meterReadingsResponse });
    }
    return react_1.default.createElement(BillingDetails, { data: data });
};
exports.BillingDetailsUI = BillingDetailsUI;
